import React from 'react';
import PropTypes from 'prop-types';

import CountdownTimer from '../../CountdownTimer';
import determineHeaderImage from './determineHeaderImage';
import siteInfoById from '../../../constants/siteInfoById';

import { useMediaQuery } from '@mui/material';
import Stack from '@mui/material/Stack';

const Header = (props) => {
	const { siteId } = props;
	const isMobile = useMediaQuery('(max-width:767px)');

	return (
		<Stack
			component='header'
			className='filterbg'
			sx={{
				width: '100%',
				background: (theme) => theme.palette.common.white,
				position: 'fixed',
				top: 0,
				zIndex: 99,
				px: { xs: 1, sm: 0 },
				height: { xs: '68px', sm: 'auto' }
			}}
		>
			<Stack
				sx={{
					my: { xs: '15px', md: '20px' }
				}}
			>
				<Stack
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					sx={{
						position: { xs: 'fixed', sm: 'relative' },
						left: { xs: '13px', sm: 'auto' }
					}}
				>
					<img
						src={determineHeaderImage(siteId)}
						alt={`${siteInfoById[siteId].name} Logo`}
						className='filter'
						style={{
							height: isMobile ? '39px' : '60px',
							display: 'block',
							objectFit: 'contain'
						}}
					/>
				</Stack>
				<Stack
					sx={{
						position: 'absolute',
						top: {
							xs: '21px',
							sm: '26px',
							md: '30px',
							lg: '40px'
						},
						right: {
							xs: '18px',
							sm: '79px',
							md: '109px',
							lg: '40px',
							xl: '40px'
						}
					}}
				>
					<CountdownTimer />
				</Stack>
			</Stack>
		</Stack>
	);
};

Header.propTypes = {
	siteId: PropTypes.number
};

export default Header;
